import crypto2 from 'crypto';
export function encrypt(plainText, secretKeyData) {
  try {
    const plainTextData = Buffer.from(plainText, 'utf8');
    const secretKey = Buffer.from(secretKeyData, 'utf8');
    const iv = secretKeyData.substring(0, 16);
    const cipher = crypto2.createCipheriv('aes-128-cbc', secretKey, iv);
    let encrypted = cipher.update(plainTextData);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return encrypted.toString('base64');
  } catch (e) {
    return undefined;
  }
}
export function signAlchemyPaySignature(appId, secret, address) {
  const plaintext = `address=${address}&appId=${appId}`;
  const ciphertext = encrypt(plaintext, secret);

  if (!ciphertext) {
    return '';
  }

  return encodeURIComponent(ciphertext);
}